<template>
    <div
        tabindex="0"
        class="date-picker-wrapper"
        @keydown.right.prevent=""
        @keydown.left.prevent=""
        @keydown.up.prevent=""
        @keydown.down.prevent=""
        @keyup.right.stop="nav(1)"
        @keyup.left.stop="nav(-1)"
        @keyup.up.stop="nav(-7)"
        @keyup.down.stop="nav(7)"
    >
        <date-picker
            class="date-picker"
            :monday-first="true"
            :inline="true"
            :language="pickerLocale"
            :disabled-dates="disabledDates"
            v-bind="$attrs"
            :value="value"
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>
import DatePicker from "vuejs-datepicker";
import moment from "moment";
import { en, de, da } from "vuejs-datepicker/dist/locale";

export default {
    components: {
        DatePicker
    },
    inheritAttrs: false,
    props: {
        value: {
            type: Date,
            default: null
        },
        disabledDates: {
            type: Object,
            default: null,
            required: false
        }
    },
    computed: {
        pickerLocale() {
            switch (this.$i18n.locale) {
                case "da":
                    return da;
                case "de":
                    return de;
                default:
                    return en;
            }
        }
    },
    methods: {
        nav: function(step) {
            const curDate = this.value || new Date();
            let nextDate = moment(curDate)
                .add(step, "days")
                .toDate();

            if (this.disabledDates && this.disabledDates.from) {
                if (moment(nextDate).isAfter(this.disabledDates.from)) return;
            }

            if (this.disabledDates && this.disabledDates.to) {
                if (moment(nextDate).isBefore(this.disabledDates.to)) {
                    if (this.value) return;
                    nextDate = moment(this.disabledDates.to).toDate();
                }
            }

            this.$announcer.polite(nextDate);

            this.$emit("input", nextDate);
        }
    }
};
</script>

<style scoped lang="scss">
$element-DatePicker-font: $body-font !default;
$element-DatePicker-color: $body-color !default;

.date-picker-wrapper {
    width: 100%;
}

.date-picker-wrapper:focus {
    outline: none;
    background: rgba(0, 0, 0, 0.03);
}

.date-picker {
    font: $element-DatePicker-font;
    color: $element-DatePicker-color;
    width: 100%;
}

.date-picker ::v-deep .vdp-datepicker__calendar {
    width: auto;
    border: none;
    background: transparent;
}

.date-picker ::v-deep .vdp-datepicker__calendar .cell.selected {
    background: $color-primary !important;
    border: 1px solid $color-primary;
    color: #fff;
}

.date-picker
    ::v-deep
    .vdp-datepicker__calendar
    .cell:not(.blank):not(.disabled).day:hover,
.date-picker
    ::v-deep
    .vdp-datepicker__calendar
    .cell:not(.blank):not(.disabled).month:hover,
.date-picker
    ::v-deep
    .vdp-datepicker__calendar
    .cell:not(.blank):not(.disabled).year:hover {
    border: 1px solid #cdcdcd;
    background: #cdcdcd;
    color: #fff;
}
</style>
